import {
    CONFIRMED_GET_DOCTORS,
    CONFIRMED_CREATE_DOCTOR_ACTION,
    CONFIRMED_DELETE_DOCTOR_ACTION,
    CONFIRMED_EDIT_DOCTOR_ACTION,
  } from "../actions/DoctorsType";
  
  const initialState = {
    doctors: [],
    num_rows: 0,
  };
  
  export default function DoctorReducer(state = initialState, action) {
    if (action.type === CONFIRMED_GET_DOCTORS) {
      return {
        ...state,
        // doctors: action.payload,
        doctors: action.payload.doctors,
        num_rows: action.payload.num_rows,
      };
    }
  

    if (action.type === CONFIRMED_CREATE_DOCTOR_ACTION) {
      const doctors = [...state.doctors];
      doctors.push(action.payload);
  
      return {
        ...state,
        doctors: [...state.doctors, action.payload],
      };
    }
  
    if (action.type === CONFIRMED_DELETE_DOCTOR_ACTION) {
      const doctors = state.doctors.filter(
        (doctor) => doctor.doctor_id !== action.payload.doctor_id
      );
  
      return {
        ...state,
        doctors,
      };
    }
  
    if (action.type === CONFIRMED_EDIT_DOCTOR_ACTION) {
      const doctors = [...state.doctors];
      const index = doctors.findIndex(
        (doctor) => doctor.doctor_id === action.payload.doctor_id
      );
  
      if (index !== -1) {
        doctors[index] = action.payload;
      }
  
      return {
        ...state,
        doctors,
      };
    }
  
    return state;
  }
  